import { Component, Inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-user-first-time-new-preinvoice',
    templateUrl: './user-first-time-new-preinvoice.component.html',
    standalone: false
})
export class UserFirstTimeNewPreinvoceDialogComponent {
  no_show_next_time: boolean = false;

  constructor(public dialogRef: MatDialogRef<UserFirstTimeNewPreinvoceDialogComponent>) { }

  accept(): void {
    this.dialogRef.close(this.no_show_next_time);  // Cierra el diálogo y devuelve true
  }

  cancel(): void {
    this.dialogRef.close(this.no_show_next_time);  // Cierra el diálogo y devuelve false
  }
}
